import { Effects } from './Effects';
import { FirestoreEffectsImpl } from './firestore/FirestoreEffectsImpl';
import { ImportEffectsImpl } from './imports/ImportEffectsImpl';
import { EventBusEffectsImpl } from './eventbus/EventBusEffectsImpl';

export const effectsImpl: Effects = {
    firestore: FirestoreEffectsImpl,
    imports: ImportEffectsImpl,
    eventbus: EventBusEffectsImpl
}